/**
 * Places Loox rating block directly under the price row (inside the price block).
 */
(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  var bootPending = false;

  function applyLooxAlignment(anchor) {
    if (!anchor) return;

    var link = anchor.querySelector('a');
    var loox = anchor.querySelector('.loox-rating');
    var content = anchor.querySelector('.loox-rating-content');
    var mobile = MOBILE_MQ.matches;

    if (mobile) {
      anchor.style.setProperty('display', 'flex', 'important');
      anchor.style.setProperty('justify-content', 'center', 'important');
      anchor.style.setProperty('align-items', 'center', 'important');
      anchor.style.setProperty('width', '100%', 'important');
      anchor.style.setProperty('text-align', 'center', 'important');

      if (link) {
        link.style.setProperty('display', 'inline-flex', 'important');
        link.style.setProperty('justify-content', 'center', 'important');
        link.style.setProperty('width', 'auto', 'important');
        link.style.setProperty('margin', '0 auto', 'important');
        link.style.setProperty('text-align', 'center', 'important');
      }

      if (loox) {
        loox.style.setProperty('display', 'inline-flex', 'important');
        loox.style.setProperty('justify-content', 'center', 'important');
        loox.style.setProperty('text-align', 'center', 'important');
        loox.style.setProperty('width', 'auto', 'important');
        loox.style.setProperty('margin-left', 'auto', 'important');
        loox.style.setProperty('margin-right', 'auto', 'important');
      }

      if (content) {
        content.style.setProperty('justify-content', 'center', 'important');
      }
    } else {
      anchor.removeAttribute('style');
      if (link) link.removeAttribute('style');
      if (loox) loox.removeAttribute('style');
      if (content) content.removeAttribute('style');
    }
  }

  function moveLooxInMeta(meta) {
    if (!meta) return;

    var anchor = meta.querySelector('.product-block--price [data-loox-rating-anchor]');
    if (!anchor) {
      anchor = meta.querySelector('[data-loox-rating-anchor]');
    }
    var blocks = meta.querySelector('[data-product-blocks]');
    if (!anchor || !blocks) return;

    if (anchor.closest('.cb-pdp-meta-row')) return;

    var looxEl = blocks.querySelector('.loox-rating');
    if (!looxEl) return;

    var looxBlock = looxEl.closest('.shopify-app-block');
    if (!looxBlock) return;

    if (looxBlock.parentElement !== anchor) {
      anchor.appendChild(looxBlock);
    }

    blocks.querySelectorAll('.shopify-app-block').forEach(function (block) {
      if (block.contains(looxBlock) || block.querySelector('.elsklip-coupon-box')) return;
      if (block.id && block.id.indexOf('loox') !== -1 && !block.querySelector('.loox-rating')) {
        block.style.setProperty('display', 'none', 'important');
        block.style.setProperty('margin', '0', 'important');
        block.style.setProperty('padding', '0', 'important');
        block.style.setProperty('min-height', '0', 'important');
      }
    });

    applyLooxAlignment(anchor);
  }

  function boot() {
    document.querySelectorAll('.product-single__meta').forEach(moveLooxInMeta);
  }

  function scheduleBoot() {
    if (bootPending) return;
    bootPending = true;
    window.requestAnimationFrame(function () {
      bootPending = false;
      boot();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (MOBILE_MQ.addEventListener) {
    MOBILE_MQ.addEventListener('change', scheduleBoot);
  } else if (MOBILE_MQ.addListener) {
    MOBILE_MQ.addListener(scheduleBoot);
  }

  document.addEventListener('variant:change', function () {
    scheduleBoot();
    window.setTimeout(boot, 250);
  });

  var observer = new MutationObserver(function () {
    scheduleBoot();
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-blocks]').forEach(function (el) {
      observer.observe(el, { childList: true, subtree: true });
    });
    window.setTimeout(boot, 500);
    window.setTimeout(boot, 1500);
  });
})();
